import cn from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import React from 'react';
import { ID, withCodes2 } from 'app/blocks/common/codes';
import processing from 'app/blocks/common/decorators/processing';
import { compose } from 'app/blocks/common/utils';
import ErrorLabel from 'app/blocks/ErrorLabel/ErrorLabel';
import withLightPanel from 'app/blocks/Panel/advanced/withLightPanel';
import VatOrTaxForm from 'app/pages/orders/panel/vat-tax';
import validationVatTax from 'app/pages/orders/panel/vat-tax/validation';
import DiscountAndBillingContext from './DiscountAndBillingContext';

@autobind
class VatTaxPanel extends React.PureComponent {
    static propTypes = {
        countryCode: PropTypes.string,
        journal: PropTypes.shape({}),
        orderWithUpdates: PropTypes.shape({ vatTaxDetails: PropTypes.shape({}) }).isRequired,
        revenueModel: PropTypes.string,
        setValidationHandler: PropTypes.func.isRequired,
        setVatTaxState: PropTypes.func.isRequired,
        vatTaxDetails: PropTypes.shape({}),
    };

    static defaultProps = {
        countryCode: undefined,
        journal: {},
        revenueModel: undefined,
        vatTaxDetails: {},
    };

    state = {
        isValidating: false,
        validationResults: undefined,
    };

    componentDidMount() {
        this.props.setValidationHandler(this.validate);
    }

    @processing('isValidating')
    async validate() {
        try {
            const { journal, orderWithUpdates } = this.props;
            await validationVatTax({ ...orderWithUpdates, journal });
            this.setState({ validationResults: undefined });
        } catch (error) {
            if (error.name === 'ValidationError') {
                this.setState({ validationResults: error });
            }

            throw error;
        }
    }

    async updateVatIdNumber(vatId) {
        const vatIdNumber = vatId ? vatId.trim() : '';

        this.props.setVatTaxState({ vatTaxDetails: { ...this.props.vatTaxDetails, vatIdNumber } });
    }

    updateTaxExemptionNumber(taxExemptionNumber) {
        this.props.setVatTaxState({ vatTaxDetails: { ...this.props.vatTaxDetails, taxExemptionNumber } });
    }

    render() {
        const {
            countryCode,
            revenueModel,
            vatTaxDetails: { taxExemptionNumber, vatIdNumber },
        } = this.props;
        const { isValidating, validationResults } = this.state;

        return (
            <section
                className={cn('payment-panel VatTaxPanel', { 'payment-panel--error': validationResults })}
                data-seleniumid="VatTaxPanel"
            >
                {validationResults && <ErrorLabel text={validationResults.message} />}

                <VatOrTaxForm
                    className="VatTaxPanel"
                    countryCode={countryCode}
                    isValidating={isValidating}
                    revenueModel={revenueModel}
                    taxExemptionNumber={taxExemptionNumber}
                    updateTaxExemptionNumber={this.updateTaxExemptionNumber}
                    updateVatIdNumber={this.updateVatIdNumber}
                    vatIdNumber={vatIdNumber}
                />
            </section>
        );
    }
}

export default compose(
    DiscountAndBillingContext.withContext(state => ({
        ...state.initiate.vatTax,
        countryCode: state?.initiate?.addresses?.mainAddress?.countryCode,
        journal: state.journal,
        orderWithUpdates: state.orderWithUpdates,
        register: state.registerPanel,
        revenueModel: state.journal.revenueModel,
        setVatTaxState: state.setVatTaxState,
        unregister: state.unregisterPanel,
    })),
    withLightPanel('vatTax'),
    withCodes2(ID.ERROR),
)(VatTaxPanel);
